var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    id: "dashboard",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,17c0.5522,0,1-0.4473,1-1c0-4.4111,3.5889-8,8-8s8,3.5889,8,8c0,0.5527,0.4478,1,1,1s1-0.4473,1-1 c0-5.5137-4.4858-10-10-10S2,10.4863,2,16C2,16.5527,2.4478,17,3,17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4473,12.1055c-0.4956-0.2471-1.0952-0.0469-1.3418,0.4473l-1.2299,2.4598C10.8314,15.0782,10,15.9401,10,17 c0,1.1025,0.897,2,2,2s2-0.8975,2-2c0-0.4061-0.1233-0.7834-0.3322-1.0993l1.2267-2.4534 C15.1416,12.9531,14.9414,12.3525,14.4473,12.1055z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.1e23fd94f33088c7c412d395fa09c76f.svg";
export { ForwardRef as ReactComponent };